<div class="holidays-dates-form border-r-16 no-gutters" *transloco="let t">
  <form class="col" [formGroup]="holidaysDatesForm" (ngSubmit)="onSubmit()">
    <div class="row no-gutters">
      <div class="col-12">
        <div class="row no-gutters">
          <div class="form-group col-md col-12">
            <label for="dayOffType">{{ t('settings/typeDaysOff') }}<span class="required-color">*</span></label>
            <ng-select
              id="dayOffType"
              formControlName="dayOffType"
              [items]="kindergartenDayOffReadDayOffType"
              bindLabel="text"
              bindValue="value"
              [placeholder]="t('child/select')"
              class="form-control"
              [clearable]="false"
            >
            </ng-select>
          </div>
          <div class="col-md col-12"></div>
        </div>
      </div>
      <div class="col-md col-12">
        <div class="row no-gutters">
          <div class="form-group col-12">
            <app-date-input
              id="date"
              [childForm]="holidaysDatesForm"
              [formControlName]="'date'"
              [placeholder]="t('child/selectBirthDate')"
              [label]="t('shared/from')"
              [required]="true"
              [requiredColor]="true"
            ></app-date-input>
          </div>
        </div>
      </div>
      <div class="col-md col-12 mt-md-0 mt-4">
        <div class="row no-gutters">
          <div class="form-group col-12">
            <app-date-input
              id="dateTo"
              [childForm]="holidaysDatesForm"
              [formControlName]="'dateTo'"
              [placeholder]="t('child/selectBirthDate')"
              [label]="t('shared/to')"
              [required]="true"
              [requiredColor]="true"
            ></app-date-input>
          </div>
        </div>
      </div>
      <div class="col-12 mt-5">
        <app-text-input
          [childForm]="holidaysDatesForm"
          [label]="t('groups/name')"
          formControlName="name"
          [required]="true"
          [formControlError]="t('announcement/announcementTitleError')"
          [requiredColor]="true"
        ></app-text-input>
      </div>
    </div>

    <hr />

    <div class="row no-gutters">
      <div class="col text-center d-flex justify-content-end">
        <button [routerLink]="links.holidaysDates()" class="btn btn-lg btn-outline-primary me-4">
          {{ t('child/cancel') }}
        </button>
        <button class="btn btn-lg btn-primary" [disabled]="holidaysDatesForm.invalid">
          {{ submitButtonText }}
        </button>
      </div>
    </div>
  </form>
</div>
